var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"p-background-secondary animation-opacity"},[_c('h1',{staticClass:"app-private-title-dark text-center"},[_vm._v(_vm._s(_vm.titulo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }